import { Component, Input } from '@angular/core';

@Component({
    selector: 'cbm-nutrition-label',
    styleUrls: ['./nutrition-label.scss'],
    templateUrl: './nutrition-label.html',
    standalone: false
})
export class XmNutritionLabelComponent {
    @Input() public response: NutritionLabel;
    @Input() public isInUse?: boolean = false;
    @Input() public isLineDetailsBBL?: boolean = false;
    @Input() public isPlanSevenOverview?: boolean = false;
}
